import AbstractApiService from 'src/services/abstractApiService';
import { api, getAuthorizationToken } from 'src/pages/APIs';
import { getOrgId } from 'src/utils/organization/org_id_helper';

declare function logError(...args: any[]): void;

interface ChatPayload {
  prompt: string;
  agent_id?: string;
  mission_id?: string;
  language?: string;
}

interface Tool {
  name: string;
  description: string;
  ext_description: string;
  parameters: {
    properties: Record<
      string,
      {
        type: string;
        description: string;
      }
    >;
    required?: string[];
  };
}

interface ToolsResponse {
  available_tools: Tool[];
}

export default class DocNetApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async chat(payload: ChatPayload): Promise<any> {
    try {
      const token = await getAuthorizationToken();
      const orgId = getOrgId();

      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: token,
        'X-Org-ID': orgId,
      };
      return super.post(api.docnet_chat, payload, { headers });
    } catch (error) {
      logError('Error running DocNet task:', error);
      throw error;
    }
  }

  public async resumeMission(
    missionId: string,
    action: string,
    resolutionNotes?: string,
  ): Promise<any> {
    try {
      const token = await getAuthorizationToken();
      const orgId = getOrgId();

      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: token,
        'X-Org-ID': orgId,
      };
      return super.post(
        `${api.docnet_mission_resume}/${missionId}/resume`,
        { action, resolution_notes: resolutionNotes },
        { headers },
      );
    } catch (error) {
      logError('Error resuming mission:', error);
      throw error;
    }
  }

  public async getAvailableTools(): Promise<ToolsResponse> {
    try {
      const headers = {
        Accept: 'application/json',
      };
      const response = await super.get(api.get_docnet_tools, { headers });
      return response as ToolsResponse;
    } catch (error) {
      logError('Error fetching available tools:', error);
      throw error;
    }
  }
}
